import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../../../constants/apiStatus";
import {
  getMealRecipeCountsAction,
  updateMealRecipeCountsAction,
} from "./mealRecipeCountsSliceActions";
import { mealRecipeCountsSliceInitialState } from "./mealRecipeCountsSliceInitialState";

const initialState = mealRecipeCountsSliceInitialState;

const mealRecipeCountsSlice = createSlice({
  name: "mealRecipeCounts",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updateCountField: (state, action) => {
      if (state.counts) {
        state.counts[action.payload.field] = action.payload.value;
      }
    },
    resetMealRecipeCountsState: () => initialState,
  },
  extraReducers: (builder) => {
    // Get Meal Recipe Counts
    builder.addCase(getMealRecipeCountsAction.fulfilled, (state, action) => {
      state.apiStatus.getCounts = API_STATUS.COMPLETED;
      state.counts = action.payload;
      state.error = null;
    });
    builder.addCase(getMealRecipeCountsAction.pending, (state) => {
      state.apiStatus.getCounts = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getMealRecipeCountsAction.rejected, (state, action) => {
      state.apiStatus.getCounts = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Update Meal Recipe Counts
    builder.addCase(updateMealRecipeCountsAction.fulfilled, (state, action) => {
      state.apiStatus.updateCounts = API_STATUS.COMPLETED;
      state.counts = action.payload;
      state.error = null;
    });
    builder.addCase(updateMealRecipeCountsAction.pending, (state) => {
      state.apiStatus.updateCounts = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(updateMealRecipeCountsAction.rejected, (state, action) => {
      state.apiStatus.updateCounts = API_STATUS.FAILED;
      state.error = action.payload;
    });
  },
});

export const { clearError, updateCountField, resetMealRecipeCountsState } =
  mealRecipeCountsSlice.actions;

export default mealRecipeCountsSlice.reducer;
